import {
  showNotification,
  hideNotification,
  removeNotification,
} from './actions/toast';

const notify =
  (events: string[]) =>
  ({ dispatch }) =>
  next =>
  action => {
    // TODO: This event check seems unnecessary, check if we can remove this?
    if (events.includes(action.type) || !action.type) {
      const {
        notificationPayload,
        notificationTitle,
        notificationDelay = 1000,
        notificationType,
        permalink = null,
        animationDelay = 150,
      } = action;
      const id = new Date().getTime();
      dispatch(
        showNotification({
          notificationPayload,
          notificationTitle,
          notificationDelay,
          notificationType,
          permalink,
          id,
        })
      );
      setTimeout(() => {
        dispatch(hideNotification(id));
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, animationDelay);
      }, notificationDelay);
    }
    return next(action);
  };

export default notify;
